import './App.css';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import routes from './router';

const router=createBrowserRouter(routes);
function App() {
  return (
    <div>
      {/* <Router>
        <Routes>
          <Route path='/' Component={Home} />
          <Route path='/voyager' element={<Voyager/>} > 
            <Route path='privacy-policy' element={<PrivacyPolicy />} />
          </Route>
        </Routes>
      </Router> */}
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
